import { Component } from 'react';

import styles from './root/root.module.scss';

/**
 * What stands in the tool container while the picker chunk downloads — §6.1's `PickerSkeleton`.
 *
 * A CLASS, mirroring `components/studio/studio-skeleton.component.tsx`: the owner's ruling is
 * class components, and `next/dynamic`'s `loading` takes any component type once wrapped in the
 * one-line adapter the page base uses (its `loading` option is TYPED as a function component).
 *
 * It reserves the editor's own minimum height rather than collapsing, because the thing under it
 * is the tallest element on the page and a collapse-then-expand is a layout shift on a route
 * whose Core Web Vitals are a ranking input. The rule lives in `root/root.module.scss` (`.skeleton`)
 * so it draws from the kit like every other picker surface (picker-fix wave, seam S1); jest maps
 * CSS modules to identity-obj-proxy, so a spec can still render this file without a stylesheet.
 */
export class PickerSkeletonComponent extends Component {
    render() {
        return (
            <div className={styles['skeleton']} data-testid="picker-skeleton" role="status" aria-live="polite">
                Loading the frame picker…
            </div>
        );
    }
}

export default PickerSkeletonComponent;
